var link_preview_default = {
  "fontElementMap": "fdVed",
  "linkPreviewContainer": "uM8-R",
  "linkPreview": "H6Ooj",
  "linkPreviewImage": "lzZ6x",
  "linkPreviewInfo": "_-8VCb",
  "linkPreviewTitle": "gdopy",
  "linkPreviewDescription": "CRH5Q",
  "linkPreviewUrl": "_30X0v"
};
export {
  link_preview_default as default
};
//# sourceMappingURL=link-preview-scss.js.map
